import { SelfTestAnswers } from "../../../../components/self-test/model/SelfTestAnswers";

export const result = (answers: SelfTestAnswers) => {
    const ans = Object.values(answers);
    const gender = ans[2];
    const isCholesterolLevelKnown = ans[3];
    const ageGroup = ans[5];
    const hasSportHabit = ans[6];
    const hasGeneticRisk = ans[7];
    const hasGeneticRisk2 = ans[8];
    const bmi = parseFloat(`${ans[9]}`);
    const isSmoking = ans[10];

    const risk = (
        ageGroup !== 'A' ||
        hasSportHabit === 'C' ||
        hasGeneticRisk === 'A' ||
        hasGeneticRisk2 === 'A' ||
        isSmoking === 'A' ||
        bmi >= 25
    );

    return { risk, gender }
}